import { createFileRoute } from "@tanstack/react-router";

import  PatternSchedulePage  from "../../../components/PatternSchedules/PatternSchedulePage.tsx";


export const Route = createFileRoute("/_layout/pattern-schedule/$patternId")({
  component: PatternSchedulePage,
});